module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qxDG4v/tc-custom/9781667451329.jpg?1682168954101",
      "alt": "This image is the cover for the book Glühwürmchen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Glühwürmchen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Wie vom Staat verordnet, ist es den Bürgern von Ebrus nicht erlaubt:"), _c('br'), _vm._v(" Den Ozean zu besuchen, der die ummauerte Stadt umgibt."), _c('br'), _vm._v(" Die Ausgangssperre zu ignorieren und nach sieben Uhr auszugehen."), _c('br'), _vm._v(" Sich mehr als dreimal im Jahr krank zu melden."), _c('br'), _vm._v(" Singen."), _c('br'), _vm._v(" Eine kurze, dystopische Geschichte über den Geist der Weihnacht."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jen Minkman, Julia Schulz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jen Minkman (1978) wurde in den Niederlanden geboren und lebte während ihres Studiums in Österreich, Belgien und dem Vereinigten Königreich. Sie lernte im Alter von drei Jahren lesen und hat seitdem nicht mehr aufgehört zu lesen. Ihre Lieblingsbücher sind Jugendliteratur, Paranormal/Fantasy, Sci-Fi, Dystopien und Romantik. Dies spiegelt sich auch in den Geschichten wider, die sie schreibt. In ihrem Heimatland ist sie eine im Buchhandel veröffentlichte Autorin von Jugendliteratur. Jenseits der niederländischen Grenze ist sie eine im Selbstverlag veröffentlichte Autorin. Ihre Bücher sind in vielen Sprachen erhältlich, auch auf Englisch."), _c('br'), _vm._v(" Jen wohnt derzeit in Den Haag, wo sie arbeitet und mit ihrem Mann und zwei lärmenden Zebrafinken lebt. Sie wird von der Literaturagentin Wampe de Veer von der Blackbird Literary Agentur in den Niederlanden vertreten."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0